var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgIcnDuplicateOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.44444 3C4.19898 3 4 3.19188 4 3.42857V15.8571C4 16.0938 4.19898 16.2857 4.44444 16.2857C4.6899 16.2857 4.88889 16.0938 4.88889 15.8571V3.85714H15.5556C15.801 3.85714 16 3.66526 16 3.42857C16 3.19188 15.801 3 15.5556 3H4.44444ZM7.99999 6.42857C7.75453 6.42857 7.55554 6.62045 7.55554 6.85714V20.5714C7.55554 20.8081 7.75453 21 7.99999 21H19.5555C19.801 21 20 20.8081 20 20.5714V6.85714C20 6.62045 19.801 6.42857 19.5555 6.42857H7.99999ZM8.44443 20.1429V7.28572H19.1111V20.1429H8.44443Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnDuplicateOutline);
export default __webpack_public_path__ + "static/media/icn-duplicate-outline.40d150accec9cc34b1bb6683f378065c.svg";
export { ForwardRef as ReactComponent };